import { initDatadog } from '@pesto/features';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import './index.css';
import { ApolloProviderWrapper } from './providers/Apollo';

initDatadog({
  applicationId: 'abda7c9b-5fbd-4c8b-afd9-b56271e53cc8',
  clientToken: 'pub3ea0c1bf38088da620e8ec5484dec1f8',
  service: 'partner-control',
  env: import.meta.env.VITE_ENV ?? 'local',
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <ApolloProviderWrapper>
        <App />
      </ApolloProviderWrapper>
    </BrowserRouter>
  </StrictMode>,
);
